import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="font-display text-lg font-bold tracking-tight text-[#0F1F2E]">{title}</h2>
    <div className="text-sm text-[#0A0A0A] leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function Privacy() {
  const [end, setEnd] = useState("the end of the programme");
  useEffect(() => { api.get("/consent/text").then(({ data }) => setEnd(data.programme_end)).catch(() => {}); }, []);
  return (
    <div className="min-h-screen bg-[#FDFDFD] px-6 py-12" data-testid="privacy-page">
      <div className="max-w-2xl mx-auto space-y-8">
        <div>
          <div className="text-[10px] font-semibold tracking-[0.24em] uppercase text-[#25AAAA]">iTeams · University of Essex</div>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-2">Privacy notice</h1>
          <p className="text-sm text-[#525252] mt-3">How the iTeams platform, delivered by The Weave on behalf of Essex Startups (University of Essex), uses your information.</p>
        </div>
        <Section title="What we hold">
          <p>Your name, University of Essex email address, student number (PRID), department and campus from the programme roster; your team, team-leader flag and C-suite role; session attendance and food/dietary choices you give us; survey completion status; notes, resources and bookings you create on the platform; and a record of your consent to be contacted.</p>
        </Section>
        <Section title="Why we use it">
          <p>To run the iTeams programme: allocating you to a team, telling you about sessions, matching you with a mentor and sponsor, ordering catering, checking attendance, and sending the opening and exit surveys. The lawful basis is your consent for emails, and the University's legitimate interest in administering a programme you have enrolled on for the rest.</p>
        </Section>
        <Section title="Emails we send">
          <p>Only about the programme: team announcements, session details and calendar invites, survey reminders, a follow-up if you miss a session, and occasional notices from the programme team. Every email has a "Stop programme emails" link, and you can turn emails off from your dashboard. We never send marketing.</p>
        </Section>
        <Section title="Who can see it">
          <p>The programme administrators at The Weave and Essex Startups. Your mentor sees your name, team and the notes your team posts. Your teammates see your name, role and team notes. Sponsors see your team's work, not your personal details. Your email, PRID, dietary needs and attendance are only visible to administrators.</p>
        </Section>
        <Section title="How long we keep it">
          <p>For the duration of the programme, until {end}, after which the platform data is reset and personal data deleted. Attendance summaries may be kept in anonymised form for programme reporting.</p>
        </Section>
        <Section title="Your rights">
          <p>You can ask to see, correct or delete your data at any time, or withdraw your consent to emails, by using your dashboard or contacting the programme team at Essex Startups. The University of Essex is the data controller; its full privacy information and Data Protection Officer contact are available on the University website.</p>
        </Section>
        <div className="text-sm pt-4 border-t border-[#E5E7EB] flex gap-4">
          <Link to="/register" className="text-[#25AAAA] font-medium hover:underline">Back to registration</Link>
          <Link to="/login" className="text-[#25AAAA] font-medium hover:underline">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
